import { validatorCreator } from 'utils/helpers/validators/validatorCreator'
import { areOnlyDigits } from 'utils/helpers/input'

export const VALIDATION_ERRORS_ENUM = {
  CANNOT_BE_EMPTY: 'The date is required.',
  SHOULD_BE_VALID: '4 digits required.',
}

const yearValidators = [
  {
    name: 'Field cannot be empty',
    isValid: ({ value, isRequired }) => !isRequired || (isRequired && !!value),
    errorMessage: VALIDATION_ERRORS_ENUM.CANNOT_BE_EMPTY,
  },
  {
    name: 'Wrong format, correct YYYY',
    isValid: ({ value }) => !value || (areOnlyDigits(value) && value.length === 4),
    errorMessage: VALIDATION_ERRORS_ENUM.SHOULD_BE_VALID,
  },
]

export const validateYear = validatorCreator(yearValidators)
